/**
 * Copyright 2021 AEKI <admin@aeki.dev>
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
import React, { useContext } from 'react'
import { stylesheet, classes } from 'typestyle'

/* Styles ======================================================================================= */
import { mb4 } from '../../styles/styleset/margin/mb4'

/* Components =================================================================================== */
import { Box } from '../../components/box/box.component'
import { Text } from '../../components/text/text.component'
import { FormContext } from '../../components/form'

/* Core ========================================================================================= */
import { runOperator } from '../../core/operators'
import { mr8 } from '../../styles/styleset/margin/mr8'
import { ml8 } from '../../styles/styleset/margin/ml8'
import { pl8 } from '../../styles/styleset/padding/pl8'

/* <FieldWrapper /> ============================================================================= */
export const FieldWrapper = (props: any) => {
  const { children, formValue, className } = props

  const { value, dispatch } = useContext(FormContext)
  const { form } = value

  const renderValue = () => {
    if (formValue && formValue.error) {
      return (
        <Text size={'xs'} baseline={'error'}>
          {formValue && formValue.error && formValue.error}
        </Text>
      )
    }
  }

  const { disabled, hidden } = runOperator(children.props, { row: form })

  if (hidden) {
    return <></>
  }

  return (
    <Box className={classes(className)} row baseline="none">
      {props.label && (
        <Text
          className={classes(mb4, disabled && STYLES.disabled)}
          as={<label htmlFor={props.name} />}
          size={'md'}
          semiBold
        // size={'md'}
        >
          {props.label}
        </Text>
      )}

      {React.cloneElement(children, { ...children.props, disabled, hidden })}
      {renderValue()}
    </Box>
  )
}

const STYLES = stylesheet({
  disabled: {
    color: 'rgb(160,160,160)',
  },
})
